export const SYSTEM_THEME = "system";

export function getSystemTheme() {
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  } catch (_) {
    return "light";
  }
}

export function getStoredThemePreference() {
  try {
    const stored = localStorage.getItem("tema");
    return stored === "light" || stored === "dark" ? stored : SYSTEM_THEME;
  } catch (_) {
    return SYSTEM_THEME;
  }
}

export function resolveThemePreference(preference) {
  return preference === "light" || preference === "dark"
    ? preference
    : getSystemTheme();
}
